var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-select',{staticStyle:{"padding":"2px"},attrs:{"value":_vm.selected,"dropdownMatchSelectWidth":false},on:{"change":_vm.handleChange}},_vm._l((_vm.options),function(m){return _c('a-select-option',{key:m.label,attrs:{"value":m.value}},[_vm._v(" "+_vm._s(m.label)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }